<script>
  import ByPersonTrendChart from './ByPersonTrendChart.vue';

  export default {
    name: 'HearingTestTrends',
    extends: ByPersonTrendChart,
    data() {
      return {
        chartId: 'hearingTestTrends',
        propertyName: 'number_audiograms',
        propertyNamePerson: 'num_audiograms',
        label: 'Audiograms',
        curYearColor: '#39C2C9',
        prevYearColor: '#FF584C',
        labelFormat: ',.0f',
      };
    },
  };
</script>
